export const SIDEBAR_OPENED_ATTRIBUTE = 'sidebarOpened';
export const ASK_AI_KB_DATA_SOURCE = 'ask_ai_kb';
